import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import FindPasswordTab from '../../components/FindPasswordTab';
import TextField from '../../components/common/TextField';
import { getHtmIdList } from './findByPasswordSlice';
import { getAlertMessageFunction } from '../../common/Util';

const Step1 = ({ stepHandler }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('findPassword');
  const { t: tCommon } = useTranslation('common');

  const tablist = [t('tablist.tab1'), t('tablist.tab2')];
  const [selectedTab, setSelectedTab] = useState(-1);
  const [form, setForm] = useState({
    name: '',
    birth: '',
  });

  const handleChange = e => {
    let { name, value } = e.target;

    if (name === 'birth') {
      value = value.replace(/[^0-9]/g, '').slice(0, 8);
    }
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = () => {
    const alertMessage = getAlertMessageFunction();

    const { name, birth } = form;
    if (selectedTab == -1) {
      // 성별을 선택해주세요
      alertMessage(t('alertMessage04'));
      return;
    }
    if (!name) {
      //이름읩력해라
      alertMessage(t('alertMessage01'));
      return;
    }
    if (!birth) {
      //생년월일입력해라
      alertMessage(t('alertMessage02'));
      return;
    }

    if (birth.length !== 8) {
      //생년월일8자리로 입력해라
      alertMessage(t('alertMessage03'));
      return;
    }

    let data = {
      htmPerNm: name,
      birthdate: birth,
      sex: selectedTab == 0 ? 'man' : 'woman',
    };

    dispatch(getHtmIdList(data));
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="subtitleBold">{t('title')}</Typography>
        <Typography variant="body2Medium">{t('description')}</Typography>
      </div>
      {/*  */}
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <TextField
          variant="login"
          placeholder={t('placeholder.name')}
          name="name"
          value={form.name}
          onChange={handleChange}
        />
        <TextField
          variant="login"
          placeholder={t('placeholder.birth')}
          name="birth"
          value={form.birth}
          onChange={handleChange}
        />
        <FindPasswordTab
          tablist={tablist}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </div>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <Button value={tCommon('confirm')} fullWidth onClick={handleSubmit} />
        <Button
          color="sub"
          value={tCommon('cancel2')}
          fullWidth
          onClick={() => navigate('/login')}
        />
      </div>
    </>
  );
};

export default Step1;
